// import i18next from 'i18next'
// import i18next from '../i18n'
// /home/zhangy64/src/eMOC/eMOC.UI/src/i18n.js
// /home/zhangy64/src/eMOC/eMOC.UI/src/common/flags.js
// import { useTranslation } from "i18next-vue";
// const { i18next, t } = useTranslation();
import { i18next } from "../i18n";

const Flags = {
  UNAUTHORIZED: 'unauthorized',
  EXTEND: 'extend',
  MAKEPERMANENT: 'makepermanent',
  MULTIPASS: 'multipass',
  OWNEREDITABLEMAKEPERMANENT: 'ownereditablemakepermanent',
  RETURNTOORIGINALCONDITION: 'returntooriginalcondition',
  SETMAKEPERMANENT: 'setmakepermanent',
  properties: {
    unauthorized: {
      key: 'unauthorized',
      value: i18next.t('Unauthorized_Expired')
    },
    extend: {
      key: 'extend',
      value: i18next.t('Extend')
    },
    makepermanent: {
      key: 'makepermanent',
      value: i18next.t('Make_Permanent')
    },
    multipass: {
      key: 'multipass',
      value: i18next.t('Multipass')
    },
    ownereditablemakepermanent: {
      key: 'ownereditablemakepermanent',
      value: i18next.t('Make_Permanent_Owner_Editable')
    },
    returntooriginalcondition: {
      key: 'returntooriginalcondition',
      value: i18next.t('Return_To_Original_Condition')
    },
    setmakepermanent: {
      key: 'setmakepermanent',
      value: i18next.t('Set_Make_Permanent')
    }
  }
}

export { Flags }
